import { CustomerPaymentMethod } from '@@types'
import { gql, useQuery } from '@apollo/client'

import type { QueryHookOptions } from '@apollo/client'

export interface CustomerActivePaymentMethodsQuery {
  customerActivePaymentMethods?: CustomerPaymentMethod[]
}

export const CUSTOMER_ACTIVE_PAYMENT_METHODS = gql`
  query CustomerActivePaymentMethods {
    customerActivePaymentMethods {
      id
      type
      last
      country
      card
      pluginId
      isDefault
    }
  }
`

export const useFetchCustomerActivePaymentMethods = (
  options?: QueryHookOptions<CustomerActivePaymentMethodsQuery>,
) => useQuery<CustomerActivePaymentMethodsQuery>(CUSTOMER_ACTIVE_PAYMENT_METHODS, options)
